import { render, staticRenderFns } from "./BuildingModal.vue?vue&type=template&id=462fa811"
import script from "./BuildingModal.vue?vue&type=script&lang=js"
export * from "./BuildingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports